import moment from "jalali-moment";

export const StatementHead = ({balance , user_data , username , metrics}:any) => {



    return (
        <>
            <div className="flex flex-col w-full px-5 mt-2 md:mt-4">
                <div className="w-full py-2  text-white text-sm flex flex-wrap items-center justify-between">

                    <div className="md:w-[calc(50%-85px)] w-full flex flex-col md:order-1 order-2">
                        <div className="w-full flex items-center md:mt-0 mt-5">
                            <div className="flex items-center">
                                <span>تاریخ :</span>
                                <span className="mr-2">{moment().locale('fa').format('YYYY/MM/DD')}</span>
                            </div>
                            <div className="flex items-center mr-5">
                                <span>ساعت :</span>
                                <span className="mr-2">{moment().locale('fa').format('HH:MM')}</span>
                            </div>
                        </div>
                        <div className="w-full flex items-center mt-5 ">
                            <span> نام صاحب حساب :</span>
                            <span className="mr-5">{user_data?.name} {user_data?.last_name}</span>
                        </div>
                    </div>

                    <div className="w-[170px] flex flex-col items-center justify-center md:order-2 order-1 md:mx-[unset] mx-auto">
                        <img src="/assets/layout/logo.png" className="w-[150px] " alt="logo" />
                        <img src="/assets/layout/textLogo.png" className="w-[150px] mt-4 ml-5" alt="logo" />
                    </div>

                    <div className="md:w-[calc(50%-85px)] w-full flex flex-col order-3 md:mt-0 mt-5">
                        <div className=" md:justify-end justify-start flex items-center  ">
                            <span> شماره اکانت :</span>
                            <span className="mr-5"> {username}</span>
                        </div>
                        <div className="  md:justify-end justify-start flex items-center mt-5">
                            <div className="flex items-center">
                                <span>لوریج :</span>
                                <span className="mr-2">1/100</span>
                            </div>
                            <div className="flex items-center mr-5">
                                <span>بالانس :</span>
                                <span className="mr-2">{balance}</span>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}